<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <v-card :loading="isLoading">
      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Llave de la extension
          </v-card-title>
        </v-img>
      </v-card-title>

      <v-card-text v-if="itemKey || isLoading" style="max-height: 450px">
        <v-row class="my-4" justify="center" align="center">
          <v-col cols="11" class="pr-0">
            <v-text-field
              ref="keyText"
              :value="itemKey"
              readonly
              filled
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="pl-1">
            <v-btn icon fab @click="handleCopyKey">
              <v-icon>
                mdi-content-copy
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-else class="my-4">
        No hay llave asociada a esta extension</v-card-text
      >

      <v-card-actions>
        <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
          Cerrar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

const SECRET = "secret";

export default {
  props: {
    isActive: {
      type: Boolean,
    },
    extension: {
      type: Object,
    },
  },

  data: () => ({
    isLoading: false,
    payload: { extension: "" },
    itemKey: null,
  }),

  watch: {
    isActive(val) {
      if (val) {
        this.payload = { extension: this.extension.extension };
        this.getKey();
      } else {
        this.payload = { extension: "" };
        this.itemKey = null;
      }
    },
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },

    async getKey() {
      this.isLoading = true;

      try {
        const { data } = await PbxHttpClient.post("/server_externo/extension/search", {
          ...this.payload,
          key: SECRET,
        });

        if (data.status !== 200) throw Error;
        this.itemKey = data?.data[0]?.data;
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }
      this.isLoading = false;
    },

    async handleCopyKey() {
      await navigator.clipboard.writeText(this.itemKey);
      this.$snotify.success(`Llave copiada al portapapeles.`, "¡Hecho!");
    },
  },
};
</script>

<style></style>
